import { ObjectMap } from '../utils/ObjectMap';

export class Base18Service {

	protected static _objectMap: ObjectMap = new ObjectMap();
	private static _messages: any;

	static get messages(): any {
		return Base18Service._messages;
	}

	static set messages(newMessages: any) {
		Base18Service._messages = newMessages;
	}

	public static getUsersLocale(defaultValue = 'en-US'): string {
		return defaultValue;
	}

	/**
	 * Get the value corresponding to the argument key and optional arguments.
	 * @param key   name for the desired i18n message object name / value
	 * @param args  substitution values corresponding to variables in the value
	 * @param count used with pluralization instrumentation
	 * @returns internationized string
	 */
	public static getMessage(key: string, args: any = null, count = 0): string | null {
		let returnedMessage: string | null = null;
		if (key) {

			let message: any = null;
			if (args && (typeof args === 'string')) {
				try {
					args = JSON.parse(args);
				}
				catch (ex) {
					args = null;
				}
			}

			if (key === 'footer.copyright') {
				console.log('break here');
			}
			const keyValue = Base18Service._objectMap.getValue(Base18Service._messages, key);
			if (keyValue) {
				if (typeof keyValue === 'string') {
					message = keyValue;

				} else if (keyValue && keyValue.plural && Number.isInteger(count)) {
					switch (count) {
						case 0:
							message = keyValue.plural.zero;
							break;
						case 1:
							message = keyValue.plural.one;
							break;
						case 2:
							message = keyValue.plural.two || keyValue.plural.many;
							break;
						case 3:
							message = keyValue.plural.three || keyValue.plural.many;
							break;
						default:
							message = keyValue.plural.many;
							break;
					}
				}
			}
			if (message) {
				if (args) {
					returnedMessage = this.applySubstitutions(message, args);
				} else {
					returnedMessage = message;
				}
				if (!returnedMessage) {
					console.log(`${key} not found.`);
				}
			} else {
				console.log(`No '${ key }' found.`);
			}
		}
		return returnedMessage;
	}

	public getMessageBlock(key: string): any {
		return Base18Service._objectMap.getValue(Base18Service._messages, key);
	}

	loaded(): boolean {
		return !!Base18Service._messages;
	}

	private static applySubstitutions(messageText: string, sub: any): string {
		if (sub) {
			if (Array.isArray(sub)) {
				sub.forEach(
					(subber: string, idx: number) => {
						const regex = new RegExp('{' + (idx + 1) + '}', 'g');
						messageText = messageText.replace(regex, subber);
					}
				);
			} else {
				const matchProperties: string[] = [];
				const regex = /{([^}]*)}/gm;
				let match: any = null;
				while ((match = regex.exec(messageText)) !== null) {
					matchProperties.push(match[1]);
				}
				matchProperties.forEach(
					(prop: string) => {
						const regexx = new RegExp('{' + prop + '}', 'g');
						messageText = messageText.replace(regexx, sub[prop]);
					}
				);
			}
		}
		return messageText.replace(/\n/g, ',');
	}
}
